/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: G_YIM-U5ADf4

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import * as pp from "@plasmicapp/react-web";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicRoundButton.module.css"; // plasmic-import: G_YIM-U5ADf4/css

import Icon64Icon from "./icons/PlasmicIcon__Icon64"; // plasmic-import: WzuZ8AOmVWTQ/icon

createPlasmicElementProxy;

export type PlasmicRoundButton__VariantMembers = {
  isDisabled: "isDisabled";
  size: "small" | "medium" | "large";
  color: "primary" | "sky" | "gray";
  notInteractable: "notInteractable";
};
export type PlasmicRoundButton__VariantsArgs = {
  isDisabled?: SingleBooleanChoiceArg<"isDisabled">;
  size?: SingleChoiceArg<"small" | "medium" | "large">;
  color?: SingleChoiceArg<"primary" | "sky" | "gray">;
  notInteractable?: SingleBooleanChoiceArg<"notInteractable">;
};
type VariantPropType = keyof PlasmicRoundButton__VariantsArgs;
export const PlasmicRoundButton__VariantProps = new Array<VariantPropType>(
  "isDisabled",
  "size",
  "color",
  "notInteractable"
);

export type PlasmicRoundButton__ArgsType = {
  link?: string;
  submitsForm?: boolean;
  target?: boolean;
  icon?: React.ReactNode;
  ariaLabel?: string;
};
type ArgPropType = keyof PlasmicRoundButton__ArgsType;
export const PlasmicRoundButton__ArgProps = new Array<ArgPropType>(
  "link",
  "submitsForm",
  "target",
  "icon",
  "ariaLabel"
);

export type PlasmicRoundButton__OverridesType = {
  root?: Flex__<"div">;
  buttonContainer?: Flex__<"div">;
};

export interface DefaultRoundButtonProps extends pp.BaseButtonProps {
  submitsForm?: boolean;
  target?: boolean;
  icon?: React.ReactNode;
  ariaLabel?: string;
  size?: SingleChoiceArg<"small" | "medium" | "large">;
  color?: SingleChoiceArg<"primary" | "sky" | "gray">;
  notInteractable?: SingleBooleanChoiceArg<"notInteractable">;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicRoundButton__RenderFunc(props: {
  variants: PlasmicRoundButton__VariantsArgs;
  args: PlasmicRoundButton__ArgsType;
  overrides: PlasmicRoundButton__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          ariaLabel: "Expand"
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "isDisabled",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.isDisabled
      },
      {
        path: "size",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.size
      },
      {
        path: "color",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.color
      },
      {
        path: "notInteractable",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          $props.notInteractable
      }
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      aria-label={(() => {
        try {
          return $props.ariaLabel;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootcolor_gray]: hasVariant($state, "color", "gray"),
          [sty.rootcolor_primary]: hasVariant($state, "color", "primary"),
          [sty.rootcolor_primary_isDisabled]:
            hasVariant($state, "color", "primary") &&
            hasVariant($state, "isDisabled", "isDisabled"),
          [sty.rootcolor_sky]: hasVariant($state, "color", "sky"),
          [sty.rootcolor_sky_isDisabled]:
            hasVariant($state, "color", "sky") &&
            hasVariant($state, "isDisabled", "isDisabled"),
          [sty.rootisDisabled]: hasVariant($state, "isDisabled", "isDisabled"),
          [sty.rootisDisabled_color_gray]:
            hasVariant($state, "color", "gray") &&
            hasVariant($state, "isDisabled", "isDisabled"),
          [sty.rootnotInteractable]: hasVariant(
            $state,
            "notInteractable",
            "notInteractable"
          ),
          [sty.rootsize_large]: hasVariant($state, "size", "large"),
          [sty.rootsize_medium]: hasVariant($state, "size", "medium"),
          [sty.rootsize_small]: hasVariant($state, "size", "small")
        }
      )}
      title={(() => {
        try {
          return $props.ariaLabel;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
    >
      <div
        data-plasmic-name={"buttonContainer"}
        data-plasmic-override={overrides.buttonContainer}
        className={classNames("all", sty.buttonContainer, {
          [sty.buttonContainerisDisabled]: hasVariant(
            $state,
            "isDisabled",
            "isDisabled"
          ),
          [sty.buttonContainersize_large]: hasVariant($state, "size", "large"),
          [sty.buttonContainersize_medium]: hasVariant(
            $state,
            "size",
            "medium"
          ),
          [sty.buttonContainersize_small]: hasVariant($state, "size", "small")
        })}
      >
        {renderPlasmicSlot({
          defaultContents: (
            <Icon64Icon
              className={classNames("all", sty.svg__pHGrg)}
              role={"img"}
            />
          ),

          value: args.icon,
          className: classNames(sty.slotTargetIcon, {
            [sty.slotTargetIconcolor_gray]: hasVariant($state, "color", "gray"),
            [sty.slotTargetIconcolor_primary_isDisabled]:
              hasVariant($state, "color", "primary") &&
              hasVariant($state, "isDisabled", "isDisabled"),
            [sty.slotTargetIconcolor_sky]: hasVariant($state, "color", "sky"),
            [sty.slotTargetIconcolor_sky_isDisabled]:
              hasVariant($state, "color", "sky") &&
              hasVariant($state, "isDisabled", "isDisabled"),
            [sty.slotTargetIconisDisabled]: hasVariant(
              $state,
              "isDisabled",
              "isDisabled"
            ),
            [sty.slotTargetIconisDisabled_color_gray]:
              hasVariant($state, "color", "gray") &&
              hasVariant($state, "isDisabled", "isDisabled")
          })
        })}
      </div>
    </div>
  ) as React.ReactElement | null;
}

function useBehavior<P extends pp.PlumeButtonProps>(
  props: P,
  ref: pp.ButtonRef
) {
  const b = pp.useButton<P, typeof PlasmicRoundButton>(
    PlasmicRoundButton,
    props,
    {
      showStartIconVariant: {
        group: "showStartIcon",
        variant: "showStartIcon"
      },
      showEndIconVariant: { group: "showEndIcon", variant: "showEndIcon" },
      isDisabledVariant: { group: "isDisabled", variant: "isDisabled" },
      contentSlot: "children",
      startIconSlot: "startIcon",
      endIconSlot: "endIcon",
      root: "root"
    },
    ref
  );
  if (b.plasmicProps.overrides.root.as === "a") {
    b.plasmicProps.overrides.root.as = PlasmicLink__;
    b.plasmicProps.overrides.root.props.component = Link;
    b.plasmicProps.overrides.root.props.platform = "nextjs";
  }
  return b;
}

const PlasmicDescendants = {
  root: ["root", "buttonContainer"],
  buttonContainer: ["buttonContainer"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  buttonContainer: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicRoundButton__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicRoundButton__VariantsArgs;
    args?: PlasmicRoundButton__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicRoundButton__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicRoundButton__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicRoundButton__ArgProps,
          internalVariantPropNames: PlasmicRoundButton__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicRoundButton__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicRoundButton";
  } else {
    func.displayName = `PlasmicRoundButton.${nodeName}`;
  }
  return func;
}

export const PlasmicRoundButton = Object.assign(
  // Top-level PlasmicRoundButton renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    buttonContainer: makeNodeComponent("buttonContainer"),

    // Metadata about props expected for PlasmicRoundButton
    internalVariantProps: PlasmicRoundButton__VariantProps,
    internalArgProps: PlasmicRoundButton__ArgProps,

    useBehavior
  }
);

export default PlasmicRoundButton;
/* prettier-ignore-end */
